import { useContext } from 'react';
import { QueryContext, useDataModel } from '@thd-nucleus/data-sources';

export const useDataProducts = ({ itemIds }) => {
  const { defaultVariables } = useContext(QueryContext);

  const { data, loading, error } = useDataModel('products', {
    variables: {
      itemIds,
      ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
        isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
      })
    },
    skip: !itemIds
  });

  return {
    data,
    loading,
    error
  };
};